/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineTimeZoneInfoDto } from './traveline-time-zone-info-dto';
import {
    TravelineTimeZoneInfoDtoFromJSON,
    TravelineTimeZoneInfoDtoFromJSONTyped,
    TravelineTimeZoneInfoDtoToJSON,
    TravelineTimeZoneInfoDtoToJSONTyped,
} from './traveline-time-zone-info-dto';
import type { TravelineRatePlanInfoDto } from './traveline-rate-plan-info-dto';
import {
    TravelineRatePlanInfoDtoFromJSON,
    TravelineRatePlanInfoDtoFromJSONTyped,
    TravelineRatePlanInfoDtoToJSON,
    TravelineRatePlanInfoDtoToJSONTyped,
} from './traveline-rate-plan-info-dto';
import type { TravelineContactInfoDto } from './traveline-contact-info-dto';
import {
    TravelineContactInfoDtoFromJSON,
    TravelineContactInfoDtoFromJSONTyped,
    TravelineContactInfoDtoToJSON,
    TravelineContactInfoDtoToJSONTyped,
} from './traveline-contact-info-dto';
import type { TravelineResourceDto } from './traveline-resource-dto';
import {
    TravelineResourceDtoFromJSON,
    TravelineResourceDtoFromJSONTyped,
    TravelineResourceDtoToJSON,
    TravelineResourceDtoToJSONTyped,
} from './traveline-resource-dto';
import type { TravelinePolicyInfoDto } from './traveline-policy-info-dto';
import {
    TravelinePolicyInfoDtoFromJSON,
    TravelinePolicyInfoDtoFromJSONTyped,
    TravelinePolicyInfoDtoToJSON,
    TravelinePolicyInfoDtoToJSONTyped,
} from './traveline-policy-info-dto';
import type { TravelineServiceInfoDto } from './traveline-service-info-dto';
import {
    TravelineServiceInfoDtoFromJSON,
    TravelineServiceInfoDtoFromJSONTyped,
    TravelineServiceInfoDtoToJSON,
    TravelineServiceInfoDtoToJSONTyped,
} from './traveline-service-info-dto';
import type { TravelineStayUnitKindDto } from './traveline-stay-unit-kind-dto';
import {
    TravelineStayUnitKindDtoFromJSON,
    TravelineStayUnitKindDtoFromJSONTyped,
    TravelineStayUnitKindDtoToJSON,
    TravelineStayUnitKindDtoToJSONTyped,
} from './traveline-stay-unit-kind-dto';
import type { TravelineAdditionalRoomStayDto } from './traveline-additional-room-stay-dto';
import {
    TravelineAdditionalRoomStayDtoFromJSON,
    TravelineAdditionalRoomStayDtoFromJSONTyped,
    TravelineAdditionalRoomStayDtoToJSON,
    TravelineAdditionalRoomStayDtoToJSONTyped,
} from './traveline-additional-room-stay-dto';

/**
 * 
 * @export
 * @interface TravelinePropertyViaAdditionalRoomInfoDto
 */
export interface TravelinePropertyViaAdditionalRoomInfoDto {
    /**
     * Property ID
     * @type {string}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    id: string;
    /**
     * User rating of the hotel
     * @type {number}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    raiting?: number | null;
    /**
     * Property name
     * @type {string}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    name: string | null;
    /**
     * Property photo gallery
     * @type {Array<TravelineResourceDto>}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    images: Array<TravelineResourceDto> | null;
    /**
     * Property ID
     * @type {string}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    propertyId?: string | null;
    /**
     * Detailed description of the property
     * @type {string}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    description?: string | null;
    /**
     * Star rating of the property
     * @type {number}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    stars?: number | null;
    /**
     * 
     * @type {TravelineStayUnitKindDto}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    stayUnitKind?: TravelineStayUnitKindDto;
    /**
     * 
     * @type {TravelineContactInfoDto}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    contactInfo?: TravelineContactInfoDto;
    /**
     * 
     * @type {TravelinePolicyInfoDto}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    policy?: TravelinePolicyInfoDto;
    /**
     * 
     * @type {TravelineTimeZoneInfoDto}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    timeZone?: TravelineTimeZoneInfoDto;
    /**
     * Property rate plans
     * @type {Array<TravelineRatePlanInfoDto>}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    ratePlans?: Array<TravelineRatePlanInfoDto> | null;
    /**
     * Room types of the property
     * @type {Array<TravelineAdditionalRoomStayDto>}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    roomTypes?: Array<TravelineAdditionalRoomStayDto> | null;
    /**
     * List of services provided by the property
     * @type {Array<TravelineServiceInfoDto>}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    services?: Array<TravelineServiceInfoDto> | null;
    /**
     * The property types are apartments or flats, which may be located at different addresses
     * @type {boolean}
     * @memberof TravelinePropertyViaAdditionalRoomInfoDto
     */
    multiLocationProperty?: boolean | null;
}



/**
 * Check if a given object implements the TravelinePropertyViaAdditionalRoomInfoDto interface.
 */
export function instanceOfTravelinePropertyViaAdditionalRoomInfoDto(value: object): value is TravelinePropertyViaAdditionalRoomInfoDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('images' in value) || value['images'] === undefined) return false;
    return true;
}

export function TravelinePropertyViaAdditionalRoomInfoDtoFromJSON(json: any): TravelinePropertyViaAdditionalRoomInfoDto {
    return TravelinePropertyViaAdditionalRoomInfoDtoFromJSONTyped(json, false);
}

export function TravelinePropertyViaAdditionalRoomInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelinePropertyViaAdditionalRoomInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'raiting': json['raiting'] == null ? undefined : json['raiting'],
        'name': json['name'],
        'images': (json['images'] == null ? null : (json['images'] as Array<any>).map(TravelineResourceDtoFromJSON)),
        'propertyId': json['propertyId'] == null ? undefined : json['propertyId'],
        'description': json['description'] == null ? undefined : json['description'],
        'stars': json['stars'] == null ? undefined : json['stars'],
        'stayUnitKind': json['stayUnitKind'] == null ? undefined : TravelineStayUnitKindDtoFromJSON(json['stayUnitKind']),
        'contactInfo': json['contactInfo'] == null ? undefined : TravelineContactInfoDtoFromJSON(json['contactInfo']),
        'policy': json['policy'] == null ? undefined : TravelinePolicyInfoDtoFromJSON(json['policy']),
        'timeZone': json['timeZone'] == null ? undefined : TravelineTimeZoneInfoDtoFromJSON(json['timeZone']),
        'ratePlans': json['ratePlans'] == null ? undefined : ((json['ratePlans'] as Array<any>).map(TravelineRatePlanInfoDtoFromJSON)),
        'roomTypes': json['roomTypes'] == null ? undefined : ((json['roomTypes'] as Array<any>).map(TravelineAdditionalRoomStayDtoFromJSON)),
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(TravelineServiceInfoDtoFromJSON)),
        'multiLocationProperty': json['multiLocationProperty'] == null ? undefined : json['multiLocationProperty'],
    };
}

  export function TravelinePropertyViaAdditionalRoomInfoDtoToJSON(json: any): TravelinePropertyViaAdditionalRoomInfoDto {
      return TravelinePropertyViaAdditionalRoomInfoDtoToJSONTyped(json, false);
  }

  export function TravelinePropertyViaAdditionalRoomInfoDtoToJSONTyped(value?: TravelinePropertyViaAdditionalRoomInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'raiting': value['raiting'],
        'name': value['name'],
        'images': (value['images'] == null ? null : (value['images'] as Array<any>).map(TravelineResourceDtoToJSON)),
        'propertyId': value['propertyId'],
        'description': value['description'],
        'stars': value['stars'],
        'stayUnitKind': TravelineStayUnitKindDtoToJSON(value['stayUnitKind']),
        'contactInfo': TravelineContactInfoDtoToJSON(value['contactInfo']),
        'policy': TravelinePolicyInfoDtoToJSON(value['policy']),
        'timeZone': TravelineTimeZoneInfoDtoToJSON(value['timeZone']),
        'ratePlans': value['ratePlans'] == null ? undefined : ((value['ratePlans'] as Array<any>).map(TravelineRatePlanInfoDtoToJSON)),
        'roomTypes': value['roomTypes'] == null ? undefined : ((value['roomTypes'] as Array<any>).map(TravelineAdditionalRoomStayDtoToJSON)),
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(TravelineServiceInfoDtoToJSON)),
        'multiLocationProperty': value['multiLocationProperty'],
    };
}

